import { useEffect, useMemo, useState } from "react"
import { Input, Button, Table, Select, DatePicker, Space, Form, Popconfirm } from 'antd'
import Modal from "antd/lib/modal/Modal"
import TextArea from "antd/lib/input/TextArea"
import { SearchOutlined, RedoOutlined } from '@ant-design/icons'
import { axiosTable, baseAxiosComplete, baseAxiosNoInfo } from '../../tool/axios'
import { SelectStores } from "../../component/common/Selects"
import BreadCrumb from '../../component/BreadCrumb'
import getPermission from '../../js/permission'
import { formItemLayout, tailLayout } from '../../js/globalParam'
import moment from 'moment';
import _ from 'lodash'

const { Column } = Table
const { Option } = Select
const { RangePicker } = DatePicker

type fetchParams = {
    performance_id: string | undefined
    store_id: string | undefined
    nursing_name: string | undefined
    nursing_phone: string | undefined
    performanceDay: any
    performance_start_date: string | undefined
    performance_end_date: string | undefined
    review_status: number | undefined
}

type pagination = {
    current: number,
    pageSize: number,
    total: number,
    showSizeChanger: boolean
}

type empRecord = {
    employee_id: string
    user_name: string
}

export default function () {

    let fetchOtherParamsTmpl: fetchParams = {
        performance_id: undefined,
        store_id: undefined,
        nursing_name: undefined,
        nursing_phone: undefined,
        performanceDay: null,
        performance_start_date: undefined,
        performance_end_date: undefined,
        review_status: undefined
    }

    const [fetchOtherParams, setFetchOtherParams] = useState<fetchParams>(fetchOtherParamsTmpl)
    const [pagination, setPagination] = useState<pagination>({
        current: 1,
        pageSize: 8,
        total: 0,
        showSizeChanger: false
    })

    const [loading, setLoading] = useState<boolean>(false)
    const [data, setData] = useState<any>([])

    const [form] = Form.useForm()
    const [recordId, setRecordId] = useState<string>('')

    const [showType, setShowType] = useState<string>('')
    const [showVisible, setShowVisible] = useState<boolean>(false)

    const [empList, setEmpList] = useState<empRecord[]>([])

    const permission: string[] = useMemo(() => {
        return getPermission()
    }, [window.location.pathname])

    useEffect(() => {
        fetch({ pagination, fetchOtherParams })
    }, [pagination.current, pagination.pageSize])

    const handleChange = (value: any, attr: string) => {
        let params: any = _.cloneDeep(fetchOtherParams)
        params[attr] = value

        setFetchOtherParams(params)
    }

    const handleDate = (param: any, attr: string, realDateParams: string[]) => {
        if (param[attr]) {
            param[realDateParams[0]] = param[attr][0].format('YYYY-MM-DD')
            param[realDateParams[1]] = param[attr][1].format('YYYY-MM-DD')

            delete param[attr]
        }
    }

    const handleSearch = () => {
        const p = { ...pagination }
        p.current = 1

        fetch({ pagination: p, fetchOtherParams })
    }

    const handleTableChange = (antPagination: any) => {
        const p = { ...pagination }
        p.current = antPagination.current
        p.pageSize = antPagination.pageSize

        setPagination(p)
    }

    const fetch = ({ pagination, fetchOtherParams }: { pagination: Object, fetchOtherParams: object }) => {
        setLoading(true)

        const iPagination: any = { ...pagination }
        iPagination.page_num = iPagination.current
        iPagination.page_size = iPagination.pageSize

        delete iPagination.current
        delete iPagination.pageSize
        delete iPagination.total

        let params: any = { ...fetchOtherParams }
        handleDate(params, 'performanceDay', ['performance_start_date', 'performance_end_date'])

        axiosTable.get('/yuesao_center/manage/performance_info/page_list', {
            params: {
                ...iPagination,
                ...params
            }

        }).then((response: any) => {
            if (response) {
                let p: any = { ...pagination }
                p.total = response.total

                setPagination(p)
                setData(response.records)
            }

            setLoading(false)
        })
    }

    const resetForm = () => {
        setFetchOtherParams(fetchOtherParamsTmpl)

        let p: any = { ...pagination }
        p.current = 1

        setPagination(p)
        fetch({ pagination: p, fetchOtherParams: fetchOtherParamsTmpl })
    }

    const handleAddOrMod = (value: string) => {
        if (value) {
            setShowType('mod')

        } else {
            form.setFieldsValue({
                store_id: '',
                nursing_id: '',
                performance_date: '',
                reward_amount: '',
                penalty_amount: '',
                reward_penalty_amount: '',
                reward_penalty_reason: ''
            })

            setShowType('add')
        }

        setRecordId(value)
        setShowVisible(true)
    }

    const confirmAddOrMod = (value: any) => {
        let id = recordId
        let url = id ? '/yuesao_center/manage/performance_info/update' : '/yuesao_center/manage/performance_info/add'

        let postData: any = {}

        if (id) {
            postData = {
                performance_id: id,
                store_id: value.store_id,
                nursing_id: value.nursing_id,
                performance_date: moment(value.performance_date).format('YYYY-MM-DD'),
                reward_amount: value.reward_amount,
                penalty_amount: value.penalty_amount,
                reward_penalty_amount: value.reward_penalty_amount,
                reward_penalty_reason: value.reward_penalty_reason
            }

        } else {
            postData = {
                store_id: value.store_id,
                nursing_id: value.nursing_id,
                performance_date: value.performance_date.format('YYYY-MM-DD'),
                reward_amount: value.reward_amount,
                penalty_amount: value.penalty_amount,
                reward_penalty_amount: value.reward_penalty_amount,
                reward_penalty_reason: value.reward_penalty_reason
            }
        }

        baseAxiosComplete.post(url, postData).then((res: any) => {
            if (res.status === 0) {
                let p: any = { ...pagination }
                p.current = 1

                setPagination(p)
                fetch({ pagination: p, fetchOtherParams: fetchOtherParamsTmpl })

                setShowVisible(false)
            }
        })
    }

    return (<div className="common-page">
        {/* 月嫂中心 -> 月嫂管理 -> 月嫂绩效 */}
        <BreadCrumb position={['月嫂中心', '月嫂绩效']} />

        <div className="common-top-form">
            <Space direction="horizontal" wrap>
                <div style={{ marginRight: 8, marginBottom: 12 }}>
                    <SelectStores placeholder="门店" value={fetchOtherParams.store_id} onChange={(value: string) => { handleChange(value, 'store_id') }} />
                </div>

                <Input style={{ marginRight: 8, marginBottom: 12, width: '150px' }} placeholder="员工名称" value={fetchOtherParams.nursing_name} onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'nursing_name') }} />
                <Input style={{ marginRight: 8, marginBottom: 12, width: '150px' }} placeholder="员工手机号" value={fetchOtherParams.nursing_phone} onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'nursing_phone') }} />

                <RangePicker
                    className="fl"
                    style={{ marginRight: 8, marginBottom: 12, width: 250 }}
                    placeholder={["绩效开始日期", "绩效结束日期"]}
                    value={fetchOtherParams.performanceDay}
                    onChange={(v: any) => { handleChange(v, 'performanceDay') }}
                />

                <Select allowClear style={{ marginRight: 8, marginBottom: 12, width: 120 }} placeholder="审核状态" value={fetchOtherParams.review_status} onChange={(value: number) => { handleChange(value, 'review_status') }}  >
                    <Option value="0">待审核</Option>
                    <Option value="1">审核通过</Option>
                    <Option value="2">审核不通过</Option>
                </Select>
            </Space>

            <div style={{ marginTop: 10 }}>
                {permission.includes('查询') && <Button style={{ marginRight: 12, marginBottom: 12 }} className="search-btn" icon={<SearchOutlined />} onClick={handleSearch} >查询</Button>}
                <Button style={{ marginRight: 12, marginBottom: 12 }} onClick={resetForm} icon={<RedoOutlined />}>重置</Button>
                {permission.includes('添加') && <Button type="primary" style={{ marginRight: 12, marginBottom: 12 }} onClick={() => { handleAddOrMod('') }}>添加</Button>}
            </div>
        </div>

        <div className="common-main">
            <Table loading={loading} dataSource={data} scroll={{ x: 'max-content' }} bordered={true} rowKey="performance_id" pagination={pagination} onChange={handleTableChange}>
                <Column
                    fixed
                    title="操作"
                    key="action"
                    render={(text, record: any) => {
                        return (<Space size="middle">
                            {record.review_status !== 1 && permission.includes('编辑') && <Button size="small" onClick={() => {
                                baseAxiosNoInfo('/yuesao_center/manage/performance_info/detail', {
                                    params: {
                                        performance_id: record.performance_id
                                    }

                                }).then((res: any) => {
                                    res && form.setFieldsValue({
                                        nursing_id: res.nursing_id,
                                        nursing_name: res.nursing_name,
                                        performance_date: res.performance_date,
                                        reward_amount: res.reward_amount,
                                        penalty_amount: res.penalty_amount,
                                        reward_penalty_amount: res.reward_penalty_amount,
                                        reward_penalty_reason: res.reward_penalty_reason
                                    })
                                })

                                handleAddOrMod(record.performance_id)
                            }} >编辑</Button>}

                            {record.review_status !== 1 && permission.includes('删除') && <Popconfirm
                                title="确定删除?"
                                onConfirm={() => {
                                    baseAxiosComplete.post('/yuesao_center/manage/performance_info/delete', {
                                        id: record.performance_id
                                    }).then(res => {
                                        if (res.status === 0) {
                                            resetForm()
                                        }
                                    })
                                }}
                                okText="是"
                                cancelText="否"
                            >
                                <Button size="small">删除</Button>
                            </Popconfirm>}
                        </Space>)
                    }}
                />

                <Column fixed title="门店名称" dataIndex="store_name" key="store_name" />
                <Column fixed title="员工名称" dataIndex="nursing_name" key="nursing_name" />
                <Column fixed title="员工手机号" dataIndex="nursing_phone" key="nursing_phone" />
                <Column fixed title="绩效日期" dataIndex="performance_date" key="performance_date" />
                <Column title="奖励金额" dataIndex="reward_amount" key="reward_amount" />
                <Column title="扣罚金额" dataIndex="penalty_amount" key="penalty_amount" />
                <Column title="实际奖惩金额" dataIndex="reward_penalty_amount" key="reward_penalty_amount" />
                <Column title="奖惩原因" dataIndex="reward_penalty_reason" key="reward_penalty_reason" />
                <Column title="审核状态" dataIndex="review_status_desc" key="review_status_desc" />
                <Column title="审核人" dataIndex="review_user_name" key="review_user_name" />
                <Column title="审核时间" dataIndex="review_time" key="review_time" />
                <Column title="创建人" dataIndex="create_user_name" key="create_user_name" />
                <Column title="创建时间" dataIndex="create_time" key="create_time" />
                <Column title="更新人" dataIndex="update_user_name" key="update_user_name" />
                <Column title="更新时间" dataIndex="update_time" key="update_time" />
            </Table>
        </div>

        {/* 月嫂中心 -> 月嫂管理 -> 月嫂绩效 -> 新增或编辑 */}
        <Modal title={showType == "add" ? "新增月嫂绩效" : "编辑月嫂绩效"} visible={showVisible} footer={false} width="500px" onCancel={() => { setShowVisible(false) }}>
            <Form {...formItemLayout} name="validate_other" form={form} onFinish={confirmAddOrMod} >
                {showType == "add" && (
                    <Form.Item label="门店" name="store_id" rules={[{ required: true, message: '必须选择门店' }]} >
                        <SelectStores onChange={((v: any) => {
                            // 查询该门店下的员工列表
                            baseAxiosNoInfo('/global/employee_list_by_position', {
                                params: {
                                    department_id: v,
                                    position_number: 21
                                }

                            }).then((res: any) => {
                                res && setEmpList(res)
                            })
                        })} />
                    </Form.Item>
                )}

                {showType == "add" && (
                    <Form.Item label="员工" name="nursing_id" rules={[{ required: true, message: '必须选择员工' }]} >
                        <Select virtual={false} showSearch filterOption={(input, option) => (option!.children as unknown as string).includes(input)}>
                            {empList.map((el: any) => (<Option value={el.employee_id} key={el.employee_id}>{el.user_name}</Option>))}
                        </Select>
                    </Form.Item>
                )}

                {showType != "add" && (
                    <Form.Item label="员工" name="nursing_name">
                        <Input readOnly />
                    </Form.Item>
                )}

                <Form.Item label="绩效日期" name="performance_date" rules={[{ required: true, message: '必须选择绩效日期' }]} getValueProps={(value) => ({ value: value ? moment(value) : null })}>
                    <DatePicker />
                </Form.Item>

                <Form.Item label="奖励金额" name="reward_amount" rules={[{ required: true, message: '必须填写奖励金额' }]} >
                    <Input type="number" placeholder="" />
                </Form.Item>

                <Form.Item label="扣罚金额" name="penalty_amount" rules={[{ required: true, message: '必须填写扣罚金额' }]} >
                    <Input type="number" placeholder="" />
                </Form.Item>

                <Form.Item label="实际奖惩金额" name="reward_penalty_amount" rules={[{ required: true, message: '必须填写实际奖惩金额' }]} >
                    <Input type="number" placeholder="" />
                </Form.Item>

                <Form.Item label="奖惩原因" name="reward_penalty_reason" rules={[{ required: true, message: '必须填写奖惩原因' }]} >
                    <TextArea style={{ height: 150 }} />
                </Form.Item>

                <Form.Item {...tailLayout}>
                    <Button type="primary" htmlType="submit">提交</Button>
                </Form.Item>
            </Form>
        </Modal>
    </div >)
}  